import { APP_INITIALIZER, Injector } from '@angular/core';
import { combineLatest } from 'rxjs';
import { RoutesService } from '@abp/ng.core';
import { EMPLOYEES_MANAGEMENT_ROUTE_VISIBILITY } from './features.token';
import { ProviderConsts } from 'src/app/shared/Constants/providers.constants';

export const EMPLOYEES_MANAGEMENT_VISIBLE_PROVIDERS = [
    {
        provide: APP_INITIALIZER,
        useFactory: employeesManagementVisibility,
        deps: [Injector],
        multi: true,
    },
];

export function employeesManagementVisibility(injector: Injector) {
    return () => {
        const isEmployeesManagementFeatureEnable$ = injector.get(EMPLOYEES_MANAGEMENT_ROUTE_VISIBILITY);
        const routes = injector.get(RoutesService);
        combineLatest([isEmployeesManagementFeatureEnable$]).subscribe(
        ([isEmployeesManagementFeatureEnable]) => {
            routes.patch(ProviderConsts.EMPLOYEE_ROUTE_PATCH_NAME, {
            invisible: !isEmployeesManagementFeatureEnable,
            });
        },
        );
    };
}
